<template>
  <div v-if="value" v-bsl="value"></div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';

import TeacherSvg from '@/assets/images/onboarding/classlist.svg';
import HomeworksSymbolsPng from '@/assets/images/onboarding/homeworks.png';
import ArrowBottomImg from '@/assets/images/onboarding/arrowbottom.svg';

export default {
  name: 'HomeworksOnlyDesktop',
  props: {
    value: {
      required: true,
    },
    isEmpty: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('students', ['student']),

    teacherImage() {
      return TeacherSvg;
    },

    homeworksSymbolsImage() {
      return HomeworksSymbolsPng;
    },

    arrowBottomImage() {
      return ArrowBottomImg;
    },

    onboardingText() {
      return `
        <div class="flex flex-col justify-center items-center">
          <h3 class="text-center">${this.$t('onboarding.homeworks_step2.title')}</h3>
          <p class="text-center py-4">${this.$t('onboarding.homeworks_step2.content')}</p>
          <div>
            <img src="${this.homeworksSymbolsImage}"/>
          </div>
        </div>`;
    },
  },
  methods: {
    ...mapMutations('layout', ['showClassList', 'hideClassList']),

    closeOnboardingTag() {
    },

    acceptOnboardingTag() {
    },

    addArrow(tour, direction) {
      const currentStepElement = tour.currentStep.el;
      const header = currentStepElement.querySelector('.shepherd-header');
      const progress = document.createElement('img');
      if (direction === 'left') {
        progress.classList.add('stepherd-custom-arrow--left');
        progress.src = `${this.arrowBottomImage}`;
      }
      header.insertBefore(
        progress,
        currentStepElement.querySelector('.shepherd-cancel-icon'),
      );
    },

    getDateWithYearlyOffset(years) {
      return moment().add(years, 'y').toDate();
    },

    startOnboarding() {
      this.$nextTick(() => {
        const vm = this;
        const tour = this.$shepherd({
          useModalOverlay: true,
          defaultStepOptions: {
            cancelIcon: {
              enabled: true,
            },
          },
        });

        tour.addStep({
          text: vm.onboardingText,
          beforeShowPromise() {
            return new Promise((resolve) => {
              vm.hideClassList();
              setTimeout(() => {
                window.scrollTo(0, 0);
                resolve();
              }, 500);
            });
          },
          attachTo: {
            element: this.isEmpty ? null : '.homeworks__tour',
            on: this.isEmpty ? null : 'left-start',
          },
          canClickTarget: false,
          modalOverlayOpeningRadius: 12,
          popperOptions: {
            placement: 'left-start',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 20],
                },
              },
            ],
          },
          buttons: [
            {
              text: this.$t('onboarding.homeworks_step2.btn'),
              action() {
                vm.acceptOnboardingTag();
                vm.$emit('input', !vm.value);
                vm.showClassList();
                return this.cancel();
              },
            },
          ],
          when: {
            show() {
              if (!vm.isEmpty) {
                vm.addArrow(this.tour, 'left');
              }
            },
            cancel() {
              vm.closeOnboardingTag();
              vm.$emit('input', !vm.value);
              vm.showClassList();
            },
          },
        });

        tour.start();

        Event.$on('cancelTour', () => {
          tour.cancel();
        });
      });
    },
  },

  beforeDestroy() {
    Event.$off('cancelTour');
  },

  watch: {
    value(value) {
      if (value) {
        this.startOnboarding();
      }
    },
  },
};
</script>
